// Shared remark plugins for our markdown surfaces.

// Disables the legacy "4+ leading spaces = code block" Markdown rule.
// Claim notes often contain text pasted from emails/Word docs whose preserved
// indentation would otherwise render as non-wrapping <pre> blocks — a single
// long indented line then forces the whole layout wider than the viewport.
// Fenced code blocks (```) still work.
export function noIndentedCode() {
  const data = this.data();
  (data.micromarkExtensions = data.micromarkExtensions || []).push({
    disable: { null: ['codeIndented'] },
  });
}
